import React from "react";
import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import { MAY_4TH_ACTIVATION, useVariableValue } from "lib/featureFlags";
import Banner from "./Banner";
import Opportunities from "./Opportunities";
import Pipelines from "./Pipelines";
import QuickLinks from "./QuickLinks";
import Welcome from "./Welcome";

function HomepageContent() {
  const mayActivationEnabled = useVariableValue(MAY_4TH_ACTIVATION, false);
  return (
    <PageWrapper mayActivationEnabled={mayActivationEnabled}>
      <Welcome />
      {!mayActivationEnabled && (
        <>
          <Banner />
          <Opportunities />
        </>
      )}
      <Pipelines />
      <QuickLinks />
    </PageWrapper>
  );
}

const PageWrapper = styled(Flex)<{ mayActivationEnabled: boolean }>(({ mayActivationEnabled }) => ({
  flexDirection: "column" as const,
  flexGrow: 1,
  flexShrink: 0,
  gap: mayActivationEnabled ? "48px" : "56px",
  height: "fit-content",
  width: "100%",
  maxWidth: "1200px",
  justifyContent: "center",
  margin: "0 auto",
  padding: "48px 24px",

  "@media screen and (min-width: 992px)": {
    padding: "48px",
  },
}));

export default HomepageContent;
